var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pixi-button',{attrs:{"interactive":!_vm.loading,"show-delay":_vm.showDelay,"z-index":5,"label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"type":_vm.type},on:{"pointerdown":_vm.next}})}
var staticRenderFns = []

export { render, staticRenderFns }